import { render, staticRenderFns } from "./RedefinePasswordForm.vue?vue&type=template&id=4bd98522&scoped=true"
import script from "./RedefinePasswordForm.vue?vue&type=script&lang=js"
export * from "./RedefinePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./RedefinePasswordForm.vue?vue&type=style&index=0&id=4bd98522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd98522",
  null
  
)

export default component.exports